<div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">

    <div class="col-md-4 col-sm-4">{{displayData.pageName}}</div>
    <div class="col-md-4 col-sm-4">
      <button class="btn btn-success addButton" (click)="openModal()"
        [hidden]="hideBtn">{{displayData.openModalButton}}</button>
      <button class="btn btn-success addButton Searchbtn" (click)="searchModal()"
        *ngIf="showSearch">{{displayData.searchModalButton}}</button>
      <button class="btn btn-success addButton Searchbtn" (click)="createIndex()"
        *ngIf="showIndex">{{displayData.indexButton}}</button>
    </div>
    <div class="col-md-4 col-sm-4">
      <button class="btn btn-primary addButton" (click)="exportToExcel()" *ngIf="showExportBtn"
        [disabled]="isExportDisable">{{displayData.exportBtn}}</button>
      <button class="btn btn-primary addButton mar-lft-rgt-15" (click)="reset()" *ngIf="showResetBtn">Reset</button>
    </div>
    <!--    <div class="col-md-4 col-sm-4">-->
    <!--      <ol class="breadcrumb cust-bread">-->
    <!--        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i-->
    <!--          class="fa fa-dashboard"></i> Home</a></li>-->
    <!--        <li class="breadcrumb-item active" aria-current="page">{{displayData.breadcrumb}}</li>-->
    <!--      </ol>-->
    <!--    </div>-->
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <!--<div class="col-md-3 col-sm-3">-->
    <!--<div class="views-title">-->
    <!--Views-->
    <!--</div>-->
    <!--<div class="views-body">-->
    <!--Folders-->
    <!--<button class="btn btn-light" (click)="toggleViews()"><i class="fa " [ngClass]="displayed?'fa-minus':'fa-plus'"></i></button>-->
    <!--</div>-->
    <!--<div class="views" [hidden]="!displayed" (click)="getTableData()">-->
    <!--<i class="fa fa-inbox"></i>-->
    <!--{{displayData.folderName}}-->
    <!--<span class="badge badge-primary pull-right">{{totalData}}</span>-->
    <!--</div>-->
    <!--</div>-->
    <div class="col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header card-header-top">
          {{displayData.tabName}}

          <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
          </div>
          <div class="pull-right font-13" [hidden]="hidePagination">
            <select class="custom-select mr-sm-2 radius-0 font-13 custom-width" [(ngModel)]="pageSizeSelected"
              (change)="onPageSizeChange($event.target.selectedIndex)">
              <option *ngFor="let pageSize of pageSizeObj" [value]="pageSize.id">{{pageSize.value}}</option>
            </select>
            <button class="btn btn-primary addButton" [disabled]="previousOffset === 0" (click)="getPreviousData()">
               </button>&nbsp;
                <button class="btn btn-danger addButton" [disabled]="nextOffset === 0" (click)="getNextData()"> >
                </button>&nbsp;
                <span><b>Page</b> {{pageNo}} <b>Of</b> {{totalPage}} &nbsp;&nbsp;<b>Total items: </b>
                  {{totalData}}</span>
                <!--<b>Total items: </b> <span>{{totalData}}</span>-->
          </div>
        </div>
        <div class="card-body ">
          <app-common-slickgrid #commonGrid>

          </app-common-slickgrid>

        </div>
      </div>
    </div>
    <div class="offset-sm-9 col-sm-3 mar-top-9">
      <button class="btn btn-primary addButton" [disabled]="prevPath === undefined" (click)="changeRouting(prevPath)">
        << Prev</button>&nbsp;
          <button class="btn btn-danger addButton" [disabled]="nextPath === undefined"
            (click)="changeRouting(nextPath)">Next >></button>
    </div>
  </div>
</div>